// Styles
import BenchmarksContainer from "./Benchmarks.styles";
import ReportsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import Tabs from "../../../../components/Common/Tabs/Tabs";

interface BenchmarksProps {}

const Benchmarks = ({}: BenchmarksProps) => {
    return (
        <BenchmarksContainer>
            <p className={"sectionTitle"}>BENCHMARKS</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="4a7b4333-93f6-4695-8c8d-13e13618ba30" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128" />,
                    },
                ]}
            />
        </BenchmarksContainer>
    );
};

export default Benchmarks;
